import { Box, Flex, Image } from '@chakra-ui/react';
import EmptyStateBox from '../../../../global/styles/images/empty-state-analytics.svg';
import LaunchdeckButton from './LaunchdeckButton';

export default function EmptyStateStandardDisplay({ reactIcon, infoText, handleCtaButtonClick, ctaButtonText }) {

  return (
    <Box className='fade-in'>
      <Flex justify='center' mt='2em' align='center' py='2.75em' border='1px solid #E5EAEF' rounded='0.5em' bg='white'>
        <Flex direction='column' justify='center' align='center'>

        {reactIcon ? <Box as={reactIcon} boxSize="3em" color="brandDark.500" /> :  <Image src={EmptyStateBox} width='2.5em' height='2.5em' color='brand.500' />}

          <Flex fontWeight='400' fontSize='0.875em' align='center' textAlign='center' lineHeight='1.5em' color='gray.500' py='1.5em' px='1em'>
            {infoText}
          </Flex>

          {handleCtaButtonClick && ctaButtonText &&
            <LaunchdeckButton bg='brand.500' color='white' px='2em' onClick={handleCtaButtonClick} label={ctaButtonText} />
          }

        </Flex>
      </Flex>
    </Box>
  )
}
